"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_sms(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "4f5897cb-e48b-4820-8563-48c219b92b46",
    "data-name": "sms-hi",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 191.5 191.5"
  }, props), /*#__PURE__*/React.createElement("title", null, "sms-hi"), /*#__PURE__*/React.createElement("g", {
    id: "44621d2f-caf0-46b3-89bd-b2de1f7afe10",
    "data-name": "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "98554e6b-f121-479b-9e2b-33e323d0e62f",
    "data-name": "Bill_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "76d5a77f-47d1-4687-b87f-74a2c9afb125",
    "data-name": "Report_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f596b78b-7ede-4618-83b9-56cd8f94d199",
    "data-name": "vodafone_store_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8e60d45b-ebd0-483d-ac77-854e665baf9b",
    "data-name": "Broadband_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6fdb448a-4637-442e-9ac0-828c1ffc1545",
    "data-name": "Business_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3a79a29c-07d3-40df-8458-27f1ba833257",
    "data-name": "Calendar_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "44068c46-de93-48e1-bb7a-4e82b282a08d",
    "data-name": "Camera_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "27befbe5-0bfa-448f-9d38-73a010524cf0",
    "data-name": "Data_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f932a7c5-4a2d-46dd-8f44-5d2f891a755f",
    "data-name": "Desktop_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "508a6c03-e532-49e8-9bad-a15a7908574d",
    "data-name": "Document_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "facb86cb-5e8f-42da-bd34-3d4af473521e",
    "data-name": "Edit_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b66a98b0-8fb6-4e29-9f31-24d88a6c48fb",
    "data-name": "Enterprise_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ce6cf97f-2d26-498f-9015-dd5fc52335f9",
    "data-name": "Call_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8fb60951-43eb-43b2-800a-3d1b393eef93",
    "data-name": "Location_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "28e29b6a-3623-43d1-b261-3db928f926e9",
    "data-name": "Mail_new_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d3480fd8-6ef0-4632-8afd-cebd32b27b87",
    "data-name": "Mail_unread_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b21071cb-4ebc-4eae-a396-0c14a2cd02a1",
    "data-name": "Mobile_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "624ae453-3ce2-480c-b1d4-e2b6e39aac5b",
    "data-name": "Network_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "93a9d5d0-ecdb-4ee1-8e14-a5945a5b5550",
    "data-name": "Reports_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a374ca6e-3753-412e-9008-e701cf4c5d28",
    "data-name": "Roaming_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2e0795b1-99cf-41a6-9239-b392ee1436af",
    "data-name": "Security_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c412da63-a004-4c07-8eaa-6095b1efe0ce",
    "data-name": "Sim_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d15f42f8-bce2-4daf-9699-5193f06aecfc",
    "data-name": "Tablet_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bfbeda89-3805-4740-b6bf-9bf8471094e4",
    "data-name": "Text_ic_hi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.31,93.43",
    transform: "translate(-0.25 -0.25)",
    fill: "none",
    stroke: "#fecb00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.25,104.71l-24,23.53V104.54h-7a13,13,0,0,1-13-13V37.22a13,13,0,0,1,13-13h78a13,13,0,0,1,13,13V91.74a13,13,0,0,1-13,13Z",
    transform: "translate(-0.25 -0.25)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.25,104.71l-24,23.53V104.54h-7a13,13,0,0,1-13-13V37.22a13,13,0,0,1,13-13h78a13,13,0,0,1,13,13V91.74a13,13,0,0,1-13,13Z",
    transform: "translate(-0.25 -0.25)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.25,102.72a13,13,0,0,0,13-13v2a13,13,0,0,1-13,13h-47l-24,23.53v-2l24-23.53Z",
    transform: "translate(-0.25 -0.25)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.25,102.54h7v2h-7a13,13,0,0,1-13-13v-2A13,13,0,0,0,29.25,102.54Z",
    transform: "translate(-0.25 -0.25)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M132.78,144.21l23.47,24v-24h7a12.78,12.78,0,0,0,13-12.74V77.22a13,13,0,0,0-13-13H85.22a13,13,0,0,0-13,13v54a13,13,0,0,0,13,13Z",
    transform: "translate(-0.25 -0.25)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.22,142.22a13,13,0,0,1-13-13v2a13,13,0,0,0,13,13h47.56l23.47,24v-2l-23.47-24Z",
    transform: "translate(-0.25 -0.25)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.28,142.22h-7v2h7a12.78,12.78,0,0,0,13-12.74v-2A12.78,12.78,0,0,1,163.28,142.22Z",
    transform: "translate(-0.25 -0.25)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 92.22,
    y: 100.01,
    width: 63.83,
    height: 3.99,
    rx: 1.99,
    ry: 1.99,
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.01,
    y: 82,
    width: 64.05,
    height: 3.99,
    rx: 1.99,
    ry: 1.99,
    fill: "#e90000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.22,
    y: 118.01,
    width: 63.83,
    height: 3.99,
    rx: 1.99,
    ry: 1.99,
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "02ed0318-f5b6-43b0-921e-3c18c05b57c9",
    "data-name": "Bounding Box",
    x: 0.25,
    y: 0.25,
    width: 191.5,
    height: 191.5,
    transform: "translate(191.75 -0.25) rotate(90)",
    fill: "none"
  })))))))))))))))))))))))))));
}

var _default = ic_sms;
exports.default = _default;